<template>
    <div class="quiz-sidebar-tile d-flex flex-column">
        <p class="quiz-title">{{ quiz.name }}</p>
        <div class="flex">
            <Button class="quiz-toggle" :label="toggleLabel" align="center" @click="toggleQuiz" />
            <Button class="quiz-toggle secondary" label="Preview" align="center" @click="previewQuiz" />
        </div>

        <ul v-if="quiz.questions" class="quiz-rows">
            <li v-for="(q, index) in quiz.questions" :key="q.key" class="quiz-row">
                <QuizQuestion :question="q" :index="index + 1" />
            </li>
        </ul>
    </div>
</template>

<script setup>
import QuizQuestion from "@/components/classroom/sidePanel/quiz/QuizQuestion.vue";
import Button from "@/components/buttons/Button.vue";
import { computed } from "vue";

const props = defineProps({
    quiz: Object
});

const emit = defineEmits(['toggleQuiz']);

const toggleLabel = computed(() => {
    return props.quiz.running ? 'End quiz' : 'Start quiz';
})

function toggleQuiz() {
    emit('toggleQuiz');
}

function previewQuiz() {
    const filloutUrl = `https://form.fillout.com/t/${props.quiz.filloutId}`;
    window.open(filloutUrl, '_blank');
}

</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.quiz-sidebar-tile {
    padding: 2vh;

    .quiz-rows {
        margin: 1rem 0 0 0;
        padding: 0;

        li.quiz-row {
            margin-bottom: 1rem;
            list-style-type: none;

            border-top: 1px solid $lighterIndigo;
            padding-top: 1rem;
        }
    }
}
</style>